import React from 'react'

const NotificationReport = () => {
  return (
    <div>NotificationReport</div>
  )
}

export default NotificationReport